export const wordsWithHyphens = {
}
